<template>
  <div class="shared-step-editor-footer-actions">
    <button
      :disabled="!canUndo"
      v-tooltip="'Undo'"
      class="shared-step-editor-footer-actions__button"
      @click="$emit('undo')"
    >
      <i class="fas fa-undo"></i>
    </button>

    <button
      :disabled="!canRedo"
      v-tooltip="'Redo'"
      class="shared-step-editor-footer-actions__button"
      @click="$emit('redo')"
    >
      <i class="fas fa-redo"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    canUndo: Boolean,
    canRedo: Boolean,
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../../sass/web/_variables.scss';

.shared-step-editor-footer-actions {
  display: flex;
  padding: 0 12px;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  left: 24px;
  right: auto;
  bottom: 12px;
  background-color: rgb(41, 48, 57);
  border: 1px solid rgb(59, 62, 67);
  z-index: 1000;
  height: 44px;
  gap: 10px;
  &__button {
    width: 17px;
    display: flex;
    outline: none;
    color: #dedfe1;
    padding: 0;
    margin: 0;
    gap: 10px;
    height: inherit;
    align-items: center;
    &:hover {
      color: $white-color;
      background: transparent;
    }
  }
}
</style>
